import React from "react";
import styled from "react-emotion";
import { Link as RRLink } from "react-router-dom";
import * as Components from "../../components";

const Link = styled(RRLink)``;

const StyledSection = styled("section")`
  height: 100%;
  padding: 20px;
  & div {
    margin-bottom: 20px;
  }
  & a {
    font-size: 16px;
    margin-left: 15px;
    padding-top: 15px;
  }
  & .all__tenants__actions {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`;

export const TenantsData = () => {
  return (
    <StyledSection>
      <Components.Widget
        title="All Tenants Reports"
        className="all__tenants__actions"
      >
        <Link to="/"> {"<"} Back to Support Dashboard</Link>
        <Link to="/all-tenants/billing-report">
          All Tenant Billing Activity
        </Link>
      </Components.Widget>
    </StyledSection>
  );
};
